export interface Field {
  typeInput: TypeInput
  type?: Type
  key: string
  label: string
  rules?: Rules
  value: string | number | null | Date | number[] | boolean;
  show: boolean
  options?: Option[]
  col?: string,
  formatNumber?: boolean
  disabled?: boolean
  accept?: string
  sizeFile?: number
  mode?: 'decimal' | 'entero'
  showCurrency?: boolean
  minDate?: Date
  maxDate?: Date
  readonly?: boolean
  truncateValue?: number
  customizeSelect?: boolean
  filter?: boolean
  editable?: boolean
  additionalData?: any
};

export type FieldTwo =
  | TextFieldTwo
  | TextareaFieldTwo
  | NumberFieldTwo
  | SelectFieldTwo
  | MultiSelectFieldTwo
  | DateFieldTwo
  | FileFieldTwo
  | ToggleFieldTwo
  | InvisibleFieldTwo

export interface BaseFieldTwo {
  col?: string;
  key: string;
  label?: string;
  rules?: Rules
  placeholder?: string;
  value: string | number | null | Date | number[] | boolean;
  show: boolean;
  disabled?: boolean;
  readonly?: boolean;
  tooltip?: string ;
  tabindex?: number;
}

export interface TextFieldTwo extends BaseFieldTwo {
  typeInput: TypeInputTwo.input;
  type?: TypeTwo.text;
  maxlength?: number;
  blockPaste?: boolean;
}

export interface TextareaFieldTwo extends BaseFieldTwo {
  typeInput: TypeInputTwo.input;
  type?: TypeTwo.textarea;
  maxlength?: number;
}

export interface NumberFieldTwo extends BaseFieldTwo {
  typeInput: TypeInputTwo.input;
  type?: TypeTwo.number;
  mode?: 'decimal' | 'entero';
  decimalSeparator?: boolean;
  showCurrency?: boolean;
  formatNumber?: boolean;
}

export interface SelectFieldTwo extends BaseFieldTwo {
  typeInput: TypeInputTwo.select;
  type?: TypeTwo.simple_select;
  options: OptionTwo[];
  filter?: boolean;
}

export interface MultiSelectFieldTwo extends BaseFieldTwo {
  typeInput: TypeInputTwo.select;
  type?: TypeTwo.multiselect;
  options: OptionTwo[];
  filter?: boolean;
  maxSelection?: number
}

export interface DateFieldTwo extends BaseFieldTwo {
  typeInput: TypeInputTwo.date;
  type?: TypeTwo.single_date;
  minDate?: Date;
  maxDate?: Date;
}

export interface FileFieldTwo extends BaseFieldTwo {
  typeInput: TypeInputTwo.file;
  type?: TypeTwo.file
  accept?: string;
  sizeFile?: number;
}

export interface ToggleFieldTwo extends BaseFieldTwo {
  typeInput: TypeInputTwo.toggle;
  type?: TypeTwo.toggle
}

export interface InvisibleFieldTwo extends BaseFieldTwo {
  typeInput: TypeInputTwo.invisible_field;
  type?: TypeTwo.invisible_field
}

export interface Option {
  text: string
  value: number | string | null
};

export interface OptionTwo {
  text: string
  value: number | string | null
  keyValue?: string
  tooltip?: string
  [key: string]: any // Permite un alcance de almacenado de información adicional de la lista de un campo select
};

export interface Rules {
  required?: boolean
  minLength?: number
  maxLength?: number
  email?: boolean
  max?: number
  min?: number
};

export interface ChangeSingleSelect {
  value: string | number | null,
  key: string | null,
  selectedField?: number | null,
};

export interface ChangeSingleSelectTwo {
  value: string | number | boolean | null,
  key: string | null,
  keyValue?: any
};

export enum TypeInput {
  input = 'input',
  select = 'select',
  date = 'date',
  file = 'file',
  check = 'check',
  toggle = 'toggle',
};

export enum Type {
  text = 'text',
  password = 'password',
  simple_select = 'simple_select',
  multiselect = 'multiselect',
  number = 'number',
  porcentaje = 'porcentaje',
  single_date = 'single',
  range_date = 'range',
  multiple_date = 'multiple',
  textarea = 'textarea',
  html = 'html',
};

export enum TypeInputTwo {
  input = 'input',
  select = 'select',
  date = 'date',
  file = 'file',
  check = 'check',
  toggle = 'toggle',
  invisible_field = 'invisible_field',
};

export enum TypeTwo {
  text = 'text',
  password = 'password',
  simple_select = 'simple_select',
  multiselect = 'multiselect',
  number = 'number',
  porcentaje = 'porcentaje',
  single_date = 'single',
  range_date = 'range',
  multiple_date = 'multiple',
  textarea = 'textarea',
  html = 'html',

  file = 'file',
  toggle = 'toggle',
  invisible_field = 'invisible_field',
};

export interface BtnCrudBasic {
  label: string;
  id: string;
}